import { motion } from 'framer-motion'
import { PieChart, BarChart3, TrendingUp, Target, Sparkles, CheckCircle } from 'lucide-react'
import FeatureLayout from '../../components/FeatureLayout'
import { useLanguage } from '../../contexts/LanguageContext'

export default function ChartsAnalyticsPage() {
  const { t } = useLanguage()

  const charts = [
    {
      icon: PieChart,
      title: t('charts.modal.pie.title'),
      description: t('charts.modal.pie.description'),
      example: t('charts.modal.pie.example'),
    },
    {
      icon: TrendingUp,
      title: t('charts.modal.line.title'),
      description: t('charts.modal.line.description'),
      example: t('charts.modal.line.example'),
    },
    {
      icon: BarChart3,
      title: t('charts.modal.bar.title'),
      description: t('charts.modal.bar.description'),
      example: t('charts.modal.bar.example'),
    },
    {
      icon: Target,
      title: t('charts.modal.trend.title'),
      description: t('charts.modal.trend.description'),
      example: t('charts.modal.trend.example'),
    },
  ]

  return (
    <FeatureLayout
      title={t('charts.modal.title')}
      subtitle={t('charts.modal.subtitle')}
      gradientFrom="from-purple-500"
      gradientTo="to-pink-500"
      icon={<BarChart3 className="h-10 w-10 text-white" />}
      featureName="Charts & Analytics"
    >
      {/* What Is Section */}
      <section className="mb-16">
        <div className="bg-gradient-to-r from-purple-500/10 to-pink-500/10 rounded-3xl p-8 lg:p-12 border border-purple-500/20">
          <div className="flex items-start gap-6">
            <div className="p-4 bg-purple-500/20 rounded-2xl">
              <Sparkles className="h-8 w-8 text-purple-400" />
            </div>
            <div>
              <h2 className="text-3xl font-bold text-white mb-4">{t('charts.modal.whatIs')}</h2>
              <p className="text-gray-300 text-lg leading-relaxed">{t('charts.modal.intro')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Available Charts */}
      <section className="mb-16">
        <h2 className="text-3xl font-bold text-white mb-8">{t('charts.modal.availableCharts')}</h2>

        <div className="grid lg:grid-cols-2 gap-6">
          {charts.map((chart, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-white/5 rounded-2xl p-8 border border-purple-500/20 hover:border-purple-500/40 transition-colors"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="p-3 bg-purple-500/20 rounded-xl">
                  <chart.icon className="h-7 w-7 text-purple-400" />
                </div>
                <h3 className="text-xl font-bold text-white">{chart.title}</h3>
              </div>
              <p className="text-gray-300 mb-3">{chart.description}</p>
              <p className="text-sm text-gray-400 italic">{chart.example}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section>
        <div className="bg-gradient-to-r from-purple-600/20 to-pink-600/20 rounded-3xl p-8 lg:p-12 border border-purple-500/30 text-center">
          <CheckCircle className="h-16 w-16 text-purple-400 mx-auto mb-6" />
          <h2 className="text-3xl font-bold text-white mb-4">{t('charts.modal.cta')}</h2>
          <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
            {t('charts.modal.ctaDescription')}
          </p>
          <a
            href="/#waitlist"
            className="inline-block px-8 py-4 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white font-semibold rounded-xl transition-all transform hover:scale-105"
          >
            Join Waitlist Now
          </a>
        </div>
      </section>
    </FeatureLayout>
  )
}
